"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChipParser = exports.CommentPartType = exports.ChipType = exports.ChipCategory = void 0;
var ChipCategory;
(function (ChipCategory) {
    ChipCategory[ChipCategory["State"] = 1] = "State";
    ChipCategory[ChipCategory["Record"] = 2] = "Record";
    ChipCategory[ChipCategory["Care"] = 3] = "Care";
})(ChipCategory || (exports.ChipCategory = ChipCategory = {}));
var ChipType;
(function (ChipType) {
    ChipType[ChipType["Human"] = 1] = "Human";
    ChipType[ChipType["Pet"] = 99] = "Pet";
})(ChipType || (exports.ChipType = ChipType = {}));
var CommentPartType;
(function (CommentPartType) {
    CommentPartType[CommentPartType["text"] = 0] = "text";
    CommentPartType[CommentPartType["chip"] = 1] = "chip";
})(CommentPartType || (exports.CommentPartType = CommentPartType = {}));
class ChipParser {
    static chipListToDictionary(chips) {
        return chips.reduce((result, chip) => {
            result[chip.name] = chip;
            return result;
        }, {});
    }
    static parse(rawText, chips) {
        // チップ名から検索しやすいように、チップ名をキーとしてChipオブジェクトを値に持つobjectに変換する
        const chipMaster = ChipParser.chipListToDictionary(chips);
        // チップ形式を含む文字列を1文字ずつ配列に展開したもの
        const chars = [...rawText];
        // console.log(chars)
        const result = [];
        // ループしていく中で$が見つかっている状態のフラグ
        let foundDollar = false;
        // ループ中のテキストが1文字ずつ追加される一時文字列。
        let tempText = "";
        for (const char of chars) {
            // console.log(char)
            // 現在の文字が$の場合
            if (char === "$") {
                // console.log("found $")
                // 以前にチップ開始の可能性のある$が出現している場合
                if (foundDollar) {
                    // console.log("previous found $")
                    // 一時文字列の先頭の$を除外
                    const chipNameCandidate = tempText.substring(1);
                    const chip = chipMaster[chipNameCandidate];
                    if (chip === undefined) {
                        // console.log(`not chip: ${tempText}`)
                        // チップマスタに存在しない場合
                        // 結果配列にテキストとして追加
                        result.push({
                            type: CommentPartType.text,
                            text: tempText
                        });
                        // この$の直前までは、チップではなかったので、この$は別のチップの始まりの可能性があるので、foundDollarはtrue
                        foundDollar = true;
                        // 蓄積されたテキストを処理したので、クリア
                        tempText = "";
                    }
                    else {
                        // console.log(`it's chip: ${chipNameCandidate}`)
                        // チップマスタに存在するチップ名の場合はチップとして扱う
                        // 結果配列にチップとして追加
                        result.push({
                            type: CommentPartType.chip,
                            text: chipNameCandidate
                        });
                        // チップの終わりの$を処理したので、$が見つかったフラグは下げる
                        foundDollar = false;
                        // チップとして蓄積されたテキストを処理したので、クリア
                        tempText = "";
                        // チップ終了の$は、一時文字列に追加しなくていいので次のループへ
                        continue;
                    }
                    // console.log(chipNameCandidate)
                }
                else {
                    // チップ開始の$がない状態で$が現れた場合はそれまでの、テキストを出力
                    if (tempText.length > 0) {
                        result.push({
                            type: CommentPartType.text,
                            text: tempText
                        });
                    }
                    // この$の直前までは、チップではなかったので、この$は別のチップの始まりの可能性があるので、foundDollarはtrue
                    foundDollar = true;
                    // 蓄積されたテキストを処理したので、クリア
                    tempText = "";
                }
            }
            // 一時文字列に追加
            tempText = `${tempText}${char}`;
            // console.log(`tempText: ${tempText}`)
        }
        // テキストが残っている場合、結果に追加
        if (tempText.length > 0) {
            result.push({
                type: CommentPartType.text,
                text: tempText
            });
        }
        // console.log(result)
        return result;
    }
}
exports.ChipParser = ChipParser;
